// frontend/src/components/Auth/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import apiClient from '../../api/client';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './Login.css';

// ── Forgot-password mini-form ──────────────────────────────────────────────────
const ForgotPasswordForm = ({ onBack }) => {
  const [email,   setEmail]   = useState('');
  const [status,  setStatus]  = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await apiClient.post('/auth/forgot-password', { email });
      setMessage(res.data.message || 'Instruções enviadas para o seu email.');
      setStatus('sent');
    } catch {
      setMessage('Erro ao enviar. Tente novamente.');
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <div className="forgot-panel">
        <div className="forgot-success">
          <span style={{ fontSize: 32 }}>📧</span>
          <p>{message}</p>
          <p style={{ fontSize: 12, color: 'var(--gray-500)', marginTop: 6 }}>
            Verifique a sua caixa de entrada e a pasta de spam.
          </p>
        </div>
        <button type="button" className="btn-back-login" onClick={onBack}>
          ← Voltar ao início de sessão
        </button>
      </div>
    );
  }

  return (
    <div className="forgot-panel">
      <h3>Recuperar Password</h3>
      <p className="forgot-hint">
        Insira o email associado à sua conta e enviaremos um link para repor a password.
      </p>
      <form onSubmit={handleSubmit}>
        {status === 'error' && (
          <div className="error-message"><span className="error-icon">⚠️</span>{message}</div>
        )}
        <div className="form-group">
          <label htmlFor="reset-email">Email</label>
          <input id="reset-email" type="email" value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="nome@empresa.pt" required autoFocus />
        </div>
        <button type="submit" className="btn-login" disabled={status === 'sending'}>
          {status === 'sending' ? 'A enviar…' : 'Enviar link de recuperação'}
        </button>
      </form>
      <button type="button" className="btn-back-login" onClick={onBack}>
        ← Voltar ao início de sessão
      </button>
    </div>
  );
};

// ── Main Login ─────────────────────────────────────────────────────────────────
const Login = () => {
  const [username,     setUsername]     = useState('');
  const [password,     setPassword]     = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error,        setError]        = useState('');
  const [loading,      setLoading]      = useState(false);
  const [view,         setView]         = useState('login');

  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!username || !password) { setError('Introduza o utilizador e a password'); return; }
    setLoading(true);
    try {
      const result = await login(username, password);
      if (result.success) { navigate('/dashboard'); }
      else { setError(result.error || 'Utilizador ou password incorretos'); }
    } catch { setError('Ocorreu um erro. Tente novamente.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src={process.env.PUBLIC_URL + '/logo_impetus.svg'} alt="Logo" />
          </div>
        </div>

        {view === 'forgot' ? (
          <ForgotPasswordForm onBack={() => setView('login')} />
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <h2>Iniciar Sessão</h2>
            {error && <div className="error-message"><span className="error-icon">⚠️</span>{error}</div>}

            <div className="form-group">
              <label htmlFor="username">Utilizador</label>
              <input id="username" type="text" value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Nome de utilizador" disabled={loading}
                autoFocus autoComplete="username" />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrap">
                <input id="password" type={showPassword ? 'text' : 'password'}
                  value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Password" disabled={loading} autoComplete="current-password" />
                <button type="button" className="btn-toggle-password" tabIndex={-1}
                  onClick={() => setShowPassword(v => !v)}
                  title={showPassword ? 'Ocultar password' : 'Mostrar password'}>
                  {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            <div className="login-forgot-row">
              <button type="button" className="btn-forgot"
                onClick={() => { setError(''); setView('forgot'); }}>
                Esqueceu a password?
              </button>
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'A entrar…' : 'Entrar'}
            </button>
          </form>
        )}

        <div className="login-footer"><p>Quantix Works v1.0</p></div>
      </div>
    </div>
  );
};

export default Login;